import { z } from 'zod';

// The box-status read: ONE resolved case, nothing else. The cascade lives in app-service — it crosses
// «Usuarios» and evaluates core-DB concepts — so the panel never computes occupancy; it maps a case to
// copy + tone. `case` is an OPEN string, deliberately not an enum: an unknown value must parse so the
// UI can fall back to no banner, instead of failing the read over a merely wider enum. Nothing about
// the other deliveries is modelled because nothing about them travels.
export const BoxStatusSchema = z.object({ case: z.string() });

export type BoxStatus = z.infer<typeof BoxStatusSchema>;
